/**
 * Audit entries written by the backend carry a `system` / `system-<source>` marker
 * (e.g. `system-camber`) as their actor instead of a user id. There is no `users`
 * document behind it, so it must never be looked up.
 *
 * @param {*} userId
 * @return {boolean}
 */
// eslint-disable-next-line import/prefer-default-export
export const isSystemActor = (userId) => typeof userId === 'string' && userId.startsWith('system');
